// src/constants/hraOrgans.js

export const MALE_ORGAN_TREE = {
  "Nervous System": [
    "brain",
    "spinal_cord",
    "eye",
    "ear",
    "pituitary",
  ],

  "Respiratory System": [
    "lungs",
    "trachea",
    "bronchi",
    "diaphragm",
  ],

  "Cardiovascular System": [
    "heart",
    "aorta",
    "artery",
    "vein",
    "blood",
    "vascular",
  ],

  "Digestive System": [
    "mouth",
    "esophagus",
    "stomach",
    "small_intestine",
    "large_intestine",
    "intestine",
    "colon",
    "rectum",
    "liver",
    "gallbladder",
    "pancreas",
    "spleen",
  ],

  "Renal / Urinary System": [
    "kidney",
    "ureter",
    "bladder",
    "urethra",
  ],

  "Endocrine System": [
    "thyroid",
    "parathyroid",
    "adrenal",
    "pituitary",
    "pancreas",
    "testes",
  ],

  "Immune / Lymphatic System": [
    "spleen",
    "thymus",
    "lymph_node",
    "lymph",
    "bone_marrow",
  ],

  "Musculoskeletal System": [
    "bone",
    "skeleton",
    "skull",
    "rib",
    "spine",
    "vertebra",
    "pelvis",
    "femur",
    "tibia",
    "humerus",
    "muscle",
    "cartilage",
    "joint",
  ],

  "Integumentary System": [
    "skin",
    "hair",
    "nail",
  ],

  "Male Reproductive System": [
    "testes",
    "penis",
    "prostate",
    "seminal_vesicle",
    "vas_deferens",
  ],
};

export const FEMALE_ORGAN_TREE = {
  "Nervous System": [
    "brain",
    "spinal_cord",
    "eye",
    "ear",
    "pituitary",
  ],

  "Respiratory System": [
    "lungs",
    "trachea",
    "bronchi",
    "diaphragm",
  ],

  "Cardiovascular System": [
    "heart",
    "aorta",
    "artery",
    "vein",
    "blood",
    "vascular",
  ],

  "Digestive System": [
    "mouth",
    "esophagus",
    "stomach",
    "small_intestine",
    "large_intestine",
    "intestine",
    "colon",
    "rectum",
    "liver",
    "gallbladder",
    "pancreas",
    "spleen",
  ],

  "Renal / Urinary System": [
    "kidney",
    "ureter",
    "bladder",
    "urethra",
  ],

  "Endocrine System": [
    "thyroid",
    "parathyroid",
    "adrenal",
    "pituitary",
    "pancreas",
    "ovaries",
  ],

  "Immune / Lymphatic System": [
    "spleen",
    "thymus",
    "lymph_node",
    "lymph",
    "bone_marrow",
  ],

  "Musculoskeletal System": [
    "bone",
    "skeleton",
    "skull",
    "rib",
    "spine",
    "vertebra",
    "pelvis",
    "femur",
    "tibia",
    "humerus",
    "muscle",
    "cartilage",
    "joint",
  ],

  "Integumentary System": [
    "skin",
    "hair",
    "nail",
  ],

  "Female Reproductive System": [
    "ovaries",
    "uterus",
    "fallopian_tube",
    "cervix",
    "vagina",
    "breast",
  ],
};

export const ORGAN_SUBPARTS = {
  brain: [
    "cerebrum",
    "cerebellum",
    "brainstem",
    "frontal_lobe",
    "temporal_lobe",
    "parietal_lobe",
    "occipital_lobe",
    "hippocampus",
    "thalamus",
    "hypothalamus",
  ],

  heart: [
    "left_atrium",
    "right_atrium",
    "left_ventricle",
    "right_ventricle",
    "aorta",
    "pulmonary_artery",
    "pulmonary_vein",
    "mitral_valve",
    "tricuspid_valve",
  ],

  lungs: [
    "left_lung",
    "right_lung",
    "bronchi",
    "bronchioles",
    "alveoli",
    "pleura",
    "diaphragm",
  ],

  liver: [
    "left_lobe",
    "right_lobe",
    "caudate_lobe",
    "quadrate_lobe",
    "portal_vein",
    "hepatic_artery",
    "hepatic_vein",
    "bile_duct",
    "gallbladder",
  ],

  kidney: [
    "left_kidney",
    "right_kidney",
    "renal_cortex",
    "renal_medulla",
    "renal_pelvis",
    "nephrons",
    "ureter",
    "renal_artery",
    "renal_vein",
  ],

  stomach: [
    "fundus",
    "body",
    "antrum",
    "pylorus",
    "mucosa",
    "greater_curvature",
    "lesser_curvature",
  ],

  intestine: [
    "duodenum",
    "jejunum",
    "ileum",
    "cecum",
    "colon",
    "rectum",
  ],

  pancreas: [
    "head",
    "body",
    "tail",
    "pancreatic_duct",
    "islets_of_langerhans",
  ],

  spleen: [
    "red_pulp",
    "white_pulp",
    "splenic_artery",
    "splenic_vein",
  ],

  thyroid: [
    "left_lobe",
    "right_lobe",
    "isthmus",
    "follicular_cells",
    "parafollicular_cells",
  ],

  bone: [
    "cortical_bone",
    "trabecular_bone",
    "bone_marrow",
    "periosteum",
    "cartilage",
  ],

  skin: [
    "epidermis",
    "dermis",
    "subcutaneous_tissue",
    "hair_follicle",
    "sweat_gland",
  ],

  ovaries: [
    "left_ovary",
    "right_ovary",
    "follicles",
    "corpus_luteum",
  ],

  uterus: [
    "fundus",
    "body",
    "endometrium",
    "myometrium",
    "cervix",
  ],

  testes: [
    "left_testis",
    "right_testis",
    "seminiferous_tubules",
    "epididymis",
    "vas_deferens",
  ],

  prostate: [
    "peripheral_zone",
    "central_zone",
    "transition_zone",
    "prostatic_urethra",
  ],

  penis: [
    "corpus_cavernosum",
    "corpus_spongiosum",
    "glans",
    "urethra",
  ],
};

export function getOrganSubparts(organ) {
  return ORGAN_SUBPARTS[String(organ || "").toLowerCase()] || [];
}

export function getOrganTreeByGender(gender) {
  return String(gender || "").toLowerCase() === "female"
    ? FEMALE_ORGAN_TREE
    : MALE_ORGAN_TREE;
}

export function formatOrganName(value) {
  return String(value || "")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}